import { createAsyncThunk } from '@reduxjs/toolkit';
import { ApplicationDataApi, DataForUpdatingApplicationFeedback } from 'api/ApplicationDataApi';

import { ErrorResponse } from './ErrorResponse';

export const createFeedbackThunk = (api: ApplicationDataApi) =>
  createAsyncThunk('/application/feedback', async (data: DataForUpdatingApplicationFeedback, thunkApi) => {
    try {
      await api.updateApplicationFeedbackData(data);
    } catch (error: unknown) {
      thunkApi.rejectWithValue((error as ErrorResponse).response.data);

      throw error;
    }
  });
